exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media screen and (min-device-width: 1904px) {\n.calculation-result[data-v-a9fc2686] {\n        margin-left: 100px !important;\n        margin-right: 100px !important;\n}\n}\n#fab[data-v-a9fc2686]{\n    position: fixed;\n    bottom: 45px;\n    right: 16px;\n    z-index: 6;\n}\n", ""]);

// exports
